export default "__VITE_ASSET__SAJdUv4Y__"